import { Dispatch, useContext, useState } from 'react';
import styled from 'styled-components';
import { ProductListingContext } from '../../../functions/data_formatting_functions';
import {
  actionSetAllAttributes,
  actionSetListingData,
  actionSetProductType,
} from '../../../store/create_listing_actions';
import { CardStyled } from '../../../../../styles/style';
import AttributeLayout from './attribute_fields_with_labels';
import AttributeImageSelection from './attributes_images_selection';
import { toast } from 'react-toastify';
import { StoreDetails } from '../../../../../data/types/stores';
import {
  AttributeType,
  Attributefullobject,
  BaseAttribute,
} from '../../../../../data/types/attributes';
import { S3ApiRepository } from '../../../../../data/repositories/s3_repository';
import { ApiRepository } from '../../../../../data/repositories/base_repository';
import { ListingState } from '../../../../../data/types/listings';
import { linkTempIds } from '../../../functions/data_formatting_functions_tsx';
import { Button } from '@nextui-org/react';

type AttributesSelectionAreaProps = {
  currentStore?: StoreDetails;
  setIsModalVisible: (value: boolean) => void;
  remove: () => void;
  addStep: (toAdd?: number) => void;
  s3Repository: S3ApiRepository;
  filesRepository: ApiRepository;
  actionGetStoreImages?: (payload: any) => { type: string; payload: any };
};

export default function AttributesSelectionArea({
  currentStore,
  setIsModalVisible,
  remove,
  addStep,
  s3Repository,
  filesRepository,
  actionGetStoreImages,
}: AttributesSelectionAreaProps) {
  const {
    state,
    dispatch,
  }: {
    state: ListingState;
    dispatch: Dispatch<any>;
  } = useContext(ProductListingContext);
  //errors is a object with key as attribute name and value as empty string
  const tempErrors: {
    [key: string]: string;
  } = {};
  state.all_attributes?.map((attr: BaseAttribute) => {
    // add attribute name as well
    tempErrors[attr.name_en] = '';
  });
  const [errors, setErrors] = useState(tempErrors);

  const renderRequiredAttributes = () => {
    const results = state?.all_attributes?.filter((attr) => !attr.custom);
    return (
      <>
        {results?.length > 0 && (
          <div className="d-flex justify-content-between py-2">
            <p className="sub_title">CATEGORY REQUIRED ATTRIBUTES</p>
            {state.productType == 1 && (
              <p
                className="sub_title small"
                style={{
                  width: ' 69px',
                  textAlign: 'right',
                }}
              >
                MULTIPLE VALUES
              </p>
            )}
          </div>
        )}
        {results?.map((attr: any, index: number) => {
          return (
            <div key={index}>
              <AttributeLayout
                key={index}
                attribute={attr}
                type={state.productType}
                errors={errors}
              />
            </div>
          );
        })}
      </>
    );
  };

  const renderCustomAttributes = () => {
    const results = state.all_attributes?.filter((attr) => attr.custom);
    return (
      <>
        {results?.length > 0 && (
          <div className="d-flex justify-content-between py-2">
            <p className="sub_title">CUSTOM FIELD ADDED BY YOU:</p>
            {state.productType == 1 && (
              <p
                className="sub_title small"
                style={{
                  width: ' 69px',
                  textAlign: 'right',
                }}
              >
                MULTIPLE VALUES
              </p>
            )}
          </div>
        )}
        {results?.map((attr: any, index: number) => {
          return (
            <div key={index}>
              <AttributeLayout
                key={index}
                attribute={attr}
                type={state.productType}
                errors={errors}
              />
            </div>
          );
        })}
      </>
    );
  };

  const updateProductType = (type: number) => {
    if (type === 0) {
      if (
        window.confirm(
          'Changing Product Type will remove all your selected values!',
        )
      ) {
        dispatch(actionSetProductType(type));

        dispatch(
          actionSetAllAttributes(
            state.all_attributes.map((item: BaseAttribute) => ({
              ...item,
              values: [],
              is_variable: false,
            })),
          ),
        );
        const cleanedNumeric = state.data?.numeric_attrs?.map((item) => {
          return {
            ...item, // Spread operator to copy existing properties
            values: [], // Set values to empty array
            is_variable: false, // Set is_variable to false
            values_images: [], // Set values_images to empty array
          };
        });

        const cleanedSelect = state.data?.select_attrs?.map((item) => {
          return {
            ...item,
            is_variable: false,
            values_en: [],
            values_ar: [],
            values_images: [],
          };
        });

        const cleanedBoolean = state.data?.boolean_attrs?.map((item) => {
          return {
            ...item,
            values: [],
            is_variable: false,
            values_images: [],
          };
        });

        dispatch(
          actionSetListingData({
            ...state.data,
            numeric_attrs: cleanedNumeric,
            select_attrs: cleanedSelect,
            boolean_attrs: cleanedBoolean,
          }),
        );
      }
    } else {
      dispatch(actionSetProductType(type));
    }
  };

  const checkValidation = async () => {
    // Check every required attribute has at least one value
    const invalid: Attributefullobject[] = [];
    const contains_invalid = state.all_attributes?.filter((attr) => {
      if (
        attr.type === AttributeType.BOOLEAN ||
        attr.type === AttributeType.NUMERIC
      ) {
        if (
          !attr?.values ||
          attr?.values?.filter((value: any) => value !== null && value !== '')
            .length < 1
        ) {
          return attr;
        }
      } else if (attr.type === AttributeType.SELECT) {
        if (!attr?.values_en || attr?.values_en?.length < 1) {
          return attr;
        }
        if (attr?.values_ar?.length !== attr?.values_en?.length) {
          toast.warning('Please enter Arabic values for all attributes!');
          return attr;
        }
      }
      if (attr.type === AttributeType.NUMERIC) {
        console.log('this is the attr', attr);
        attr.values?.forEach((value: any) => {
          const upperLimit =
            state.data?.official_attributes &&
            state.data?.official_attributes[attr.id]?.attribute_full_object !==
              undefined
              ? state.data?.official_attributes[attr.id]?.attribute_full_object
                  .hard_upper_limit
              : attr.hard_upper_limit;

          const lowerLimit =
            state.data?.official_attributes &&
            state.data?.official_attributes[attr.id]?.attribute_full_object !==
              undefined
              ? state.data?.official_attributes[attr.id]?.attribute_full_object
                  .hard_bottom_limit
              : attr.hard_bottom_limit;

          if (
            (upperLimit && Number(value) > parseFloat(upperLimit)) ||
            (lowerLimit && Number(value) < parseFloat(lowerLimit))
          ) {
            invalid.push(attr);
          }
        });
      }
    });
    console.log('this is invalid', contains_invalid);
    contains_invalid.push(...invalid);
    // check values and their images are equals in length
    const results = state.all_attributes?.filter((attr) => {
      if (attr.is_variable) {
        if (state?.data?.selectedImages[attr.name_en]) {
          const count = Object.keys(
            state?.data?.selectedImages[attr.name_en],
          ).length;
          if (count > 0) {
            if (
              attr.values_en?.length !==
              Object.keys(state?.data?.selectedImages[attr.name_en]).filter(
                (value: any) =>
                  value &&
                  value !== null &&
                  value !== undefined &&
                  value !== '',
              ).length
            ) {
              return attr;
            }
            let hasEmpty = false;
            let hasValue = false;
            Object.keys(state?.data?.selectedImages[attr.name_en]).forEach(
              (value: any) => {
                if (value.id) {
                  hasValue = true;
                } else {
                  hasEmpty = true;
                }
              },
            );
            if (hasEmpty && hasValue) {
              return attr;
            }
          }
        }
      }
    });
    const attribute_errors: {
      [key: string]: string;
    } = {};

    state.all_attributes?.map((attr) => {
      // add attribute name as well
      attribute_errors[attr.name_en] = '';
      attr.is_variable =
        (attr.is_variable &&
          ((attr?.values && attr?.values?.length > 1) ||
            (attr?.values_en && attr?.values_en?.length > 1) ||
            (attr?.values_ar && attr?.values_ar?.length > 1))) ??
        false;
    });

    if (contains_invalid.length > 0) {
      contains_invalid.forEach(function (item, index: number) {
        attribute_errors[item.name_en] =
          `Attribute ${item.name_en} is not valid`;
        setTimeout(function () {
          toast.warning(
            //TODO make it bold
            item.name_en +
              ' is either empty or not valid!\n' +
              'Please enter at least one value for every attributes!',
          );
        }, index * 800);
      });
    }
    console.log('dis is errors', attribute_errors);
    setErrors(attribute_errors);

    if (results.length > 0) {
      toast.warning(
        'Please add all required images for (' + results[0].name_en + ')',
      );
      results.forEach(function (item, index: number) {
        if (attribute_errors[item.name_en]) {
          attribute_errors[item.name_en] += '\n';
        }
        attribute_errors[item.name_en] += `Please add all required images`;
        setTimeout(function () {
          toast.warning(
            //TODO make it bold
            'Please add all required images for (' + item.name_en + ')',
          );
        }, index * 800);
      });
    }

    if (results.length !== 0 || contains_invalid.length !== 0) {
      return;
    }

    await linkTempIds(state, dispatch);
    toast.info(
      'Please wait while we are fetching categories & building combinations',
    );
    setTimeout(() => {
      addStep();
    }, 1000);
  };
  return (
    <Wrapper>
      <div className="grid_container">
        <div className="all_specifications">
          <CardStyled>
            <SpecStyle>
              {/* Listing Type Starts */}
              <div className="head">
                <h1 className="flex">
                  Listing Type
                  <div className="position-relative info-hover text-start">
                    <div className="info-sign poppins  text-white center">
                      ?
                    </div>
                    <div className="info-div">
                      Choose the type of listing you want to create. If the
                      listing has variations (e.g. different sizes or colors)
                      select Product with variations, otherwise select Simple
                      Product.
                    </div>
                  </div>
                </h1>
                <div className="checkBoxes flex">
                  <div className="form-check flex">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="product_type"
                      id="product_type0"
                      checked={state.productType == 0 ? true : false}
                      onChange={() => updateProductType(0)}
                    />
                    <label className="form-check-label" htmlFor="product_type0">
                      Simple Product
                    </label>
                  </div>
                  <div className="form-check used flex">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="product_type"
                      id="product_type1"
                      checked={state.productType == 1 ? true : false}
                      onChange={() => updateProductType(1)}
                    />
                    <label className="form-check-label" htmlFor="product_type1">
                      Product With Variations
                    </label>
                  </div>
                </div>
              </div>
              {/* Listing Type Ends */}

              {/* Specifications Start */}
              <div>
                <div
                  className="head"
                  style={{ border: 'none', marginBottom: '0' }}
                >
                  <h1 className="flex">
                    Specifications
                    <div className="position-relative info-hover text-start">
                      <div className="info-sign poppins text-white center">
                        ?
                      </div>
                      <div className="info-div">
                        All attributes added by Silal are required. You can add
                        a custom attribute by clicking on the + Add custom field
                        button below.
                      </div>
                    </div>
                  </h1>
                  <p>
                    Keep in mind, changing any of the following will erase the
                    combinations table.
                  </p>
                </div>

                {/* REQUIRED Attributes Starts */}
                {renderRequiredAttributes()}
                <br />
                {/* REQUIRED Attributes ENDS */}
                {/* Custom Attributes Starts */}
                {renderCustomAttributes()}
                {/* Custom Attributes ENDS */}
              </div>
              {/* Specification Ends */}
              <div className="butns my-4 d-flex justify-content-between">
                <div className="start">
                  <Button onClick={remove}>Back</Button>
                </div>
                <div className="end">
                  <Button
                    className="mx-3"
                    color={'success'}
                    variant={'flat'}
                    onClick={() => setIsModalVisible(true)}
                    style={{
                      backgroundColor: '#cdefdb',
                    }}
                  >
                    + Add custom field
                  </Button>

                  <Button
                    color={'success'}
                    onClick={async () => {
                      await checkValidation();
                    }}
                    style={{
                      width: '150px',
                    }}
                  >
                    Next step
                  </Button>
                </div>
              </div>
            </SpecStyle>
          </CardStyled>
        </div>

        <AttributeImageSelection
          actionGetStoreImages={actionGetStoreImages}
          currentStore={currentStore}
          s3Repository={s3Repository}
          filesRepository={filesRepository}
        />
      </div>
    </Wrapper>
  );
}

const SpecStyle = styled.div`
  font-family: 'Lato';
  font-style: normal;
  .flex {
    display: flex;
    align-items: center !important;
  }
  .text-white {
    color: white;
    text-align: center;
  }
  .back {
    border: 1px solid #05ae4b;
    border-radius: 5px;
  }
  .checkBoxes {
    padding: 15px 0px;
    h6 {
      font-family: 'Lato';
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      color: rgba(0, 39, 51, 0.5);
      padding: 6px;
      padding-right: 16px;
    }
  }
  .form-check-input:checked {
    background-color: #05ae4b;
  }
  .form-check {
    label {
      font-weight: 400;
      font-size: 15px;
      color: #002733;
    }
  }
  .used {
    padding-left: 39px;
  }
  .form-group {
    // width: 100%;
    .screen {
      width: 100%;
    }
    label {
      font-family: 'Lato';
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      color: rgba(0, 39, 51, 0.5);
    }
  }
  .info-hover {
    margin-left: 7px;
  }

  .attributes-icons {
    min-width: 80px;
    float: right;
  }

  .screenImg {
    margin-top: 20px;
  }
`;
const Wrapper = styled.div`
  /* border: 1px solid red; */
  .grid_container {
    display: grid;
    grid-template-columns: 9fr 3fr;
    grid-column-gap: 20px;
    max-width: 100%;
  }
  .all_specifications {
  }
`;
